import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A nuclear power station: the unmistakable domed containment building (a white
// cylinder capped by a hemisphere), a low turbine hall beside it and a small
// concrete cooling tower with a steam wisp. A trefoil sign marks the front.
const DOME = "#e7e8ea";
const SHADE = "#cfd1d4";
const HALL = "#b6bbc1";
const ROOF = "#73787e";
const COOL = "#cfcabb";
const TREFOIL = "#f2c14e";

export const nuclearReactor = defineModel({
  id: "nuclear-reactor",
  batchId: "electric",
  name: "Nuclear reactor",
  tags: ["building", "electric", "power", "energy", "nuclear", "plant"],
  summary: "A domed reactor containment with turbine hall and cooling tower.",
  footprint: 1.0,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.9, 0.12, 1.4), color: "#6f6f74", position: [0, 0.06, 0] },
      // Containment: a squat wide cylinder + hemisphere dome (not a tall bullet).
      { geometry: new THREE.CylinderGeometry(0.5, 0.52, 0.5, 18), color: DOME, position: [-0.42, 0.37, 0.05] },
      { geometry: new THREE.SphereGeometry(0.5, 18, 9, 0, Math.PI * 2, 0, Math.PI / 2), color: SHADE, position: [-0.42, 0.62, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.52, 0.52, 0.05, 18), color: "#b7b9bc", position: [-0.42, 0.12, 0.05] },
      // Yellow radiation warning roundel on the front of the containment.
      { geometry: new THREE.CylinderGeometry(0.12, 0.12, 0.025, 18), color: "#1c1c1e", position: [-0.42, 0.34, 0.55], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.085, 0.085, 0.03, 18), color: TREFOIL, position: [-0.42, 0.34, 0.56], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.028, 0.028, 0.035, 12), color: "#1c1c1e", position: [-0.42, 0.34, 0.57], rotation: [Math.PI / 2, 0, 0] },
      // Turbine hall.
      { geometry: new THREE.BoxGeometry(0.8, 0.44, 0.74), color: HALL, position: [0.42, 0.34, 0.12] },
      { geometry: new THREE.BoxGeometry(0.84, 0.06, 0.78), color: ROOF, position: [0.42, 0.59, 0.12] },
      { geometry: new THREE.BoxGeometry(0.66, 0.16, 0.02), color: "#3a4a55", position: [0.42, 0.34, 0.5] },
      { geometry: new THREE.BoxGeometry(0.16, 0.28, 0.03), color: "#5a6066", position: [0.42, 0.2, 0.5] },
      // Cooling tower: a proper little hyperboloid with a thin steam wisp.
      { geometry: new THREE.CylinderGeometry(0.18, 0.3, 0.36, 14), color: COOL, position: [0.66, 0.3, -0.5] },
      { geometry: new THREE.CylinderGeometry(0.26, 0.18, 0.3, 14), color: COOL, position: [0.66, 0.63, -0.5] },
      { geometry: new THREE.CylinderGeometry(0.22, 0.22, 0.04, 14), color: "#3a3a3e", position: [0.66, 0.79, -0.5] },
      { geometry: new THREE.SphereGeometry(0.2, 9, 6), color: "#eef0f2", position: [0.66, 0.9, -0.5], scale: [1, 0.55, 1] },
      { geometry: new THREE.SphereGeometry(0.13, 8, 6), color: "#fafbfc", position: [0.62, 1.05, -0.47] },
    ];
  },
  animations: [],
});
